var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 569,
    height: 580,
    viewBox: "0 0 569 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_789_9267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 580,
    height: 580
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 4.60317L13.8095 6.90476L9.20635 9.20635L6.90476 13.8095L4.60317 9.20635L0 6.90476L4.60317 4.60317L6.90476 0L9.20635 4.60317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 4.60317L41.4287 6.90476L36.8255 9.20635L34.5239 13.8095L32.2223 9.20635L27.6191 6.90476L32.2223 4.60317L34.5239 0L36.8255 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 4.60317L69.0478 6.90476L64.4446 9.20635L62.143 13.8095L59.8415 9.20635L55.2383 6.90476L59.8415 4.60317L62.143 0L64.4446 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 4.60317L96.6669 6.90476L92.0638 9.20635L89.7622 13.8095L87.4606 9.20635L82.8574 6.90476L87.4606 4.60317L89.7622 0L92.0638 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 4.60317L124.286 6.90476L119.683 9.20635L117.381 13.8095L115.08 9.20635L110.477 6.90476L115.08 4.60317L117.381 0L119.683 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 4.60317L151.905 6.90476L147.302 9.20635L145 13.8095L142.699 9.20635L138.096 6.90476L142.699 4.60317L145 0L147.302 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 4.60317L179.523 6.90476L174.92 9.20635L172.619 13.8095L170.317 9.20635L165.714 6.90476L170.317 4.60317L172.619 0L174.92 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 4.60317L207.143 6.90476L202.539 9.20635L200.238 13.8095L197.936 9.20635L193.333 6.90476L197.936 4.60317L200.238 0L202.539 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 4.60317L234.762 6.90476L230.158 9.20635L227.857 13.8095L225.555 9.20635L220.952 6.90476L225.555 4.60317L227.857 0L230.158 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 4.60317L262.381 6.90476L257.778 9.20635L255.476 13.8095L253.174 9.20635L248.571 6.90476L253.174 4.60317L255.476 0L257.778 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 4.60317L290 6.90476L285.397 9.20635L283.095 13.8095L280.794 9.20635L276.19 6.90476L280.794 4.60317L283.095 0L285.397 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 4.60317L317.619 6.90476L313.016 9.20635L310.714 13.8095L308.413 9.20635L303.81 6.90476L308.413 4.60317L310.714 0L313.016 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 4.60317L345.238 6.90476L340.635 9.20635L338.333 13.8095L336.032 9.20635L331.429 6.90476L336.032 4.60317L338.333 0L340.635 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 4.60317L372.857 6.90476L368.254 9.20635L365.953 13.8095L363.651 9.20635L359.048 6.90476L363.651 4.60317L365.953 0L368.254 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 4.60317L400.477 6.90476L395.873 9.20635L393.572 13.8095L391.27 9.20635L386.667 6.90476L391.27 4.60317L393.572 0L395.873 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 4.60317L428.096 6.90476L423.492 9.20635L421.191 13.8095L418.889 9.20635L414.286 6.90476L418.889 4.60317L421.191 0L423.492 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 4.60317L455.714 6.90476L451.111 9.20635L448.809 13.8095L446.507 9.20635L441.904 6.90476L446.507 4.60317L448.809 0L451.111 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 4.60317L483.333 6.90476L478.73 9.20635L476.428 13.8095L474.127 9.20635L469.523 6.90476L474.127 4.60317L476.428 0L478.73 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 4.60317L510.952 6.90476L506.349 9.20635L504.047 13.8095L501.746 9.20635L497.143 6.90476L501.746 4.60317L504.047 0L506.349 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 4.60317L538.571 6.90476L533.968 9.20635L531.666 13.8095L529.365 9.20635L524.762 6.90476L529.365 4.60317L531.666 0L533.968 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 4.60317L566.19 6.90476L561.587 9.20635L559.286 13.8095L556.984 9.20635L552.381 6.90476L556.984 4.60317L559.286 0L561.587 4.60317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 32.2223L13.8095 34.5239L9.20635 36.8255L6.90476 41.4287L4.60317 36.8255L0 34.5239L4.60317 32.2223L6.90476 27.6191L9.20635 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 32.2223L41.4287 34.5239L36.8255 36.8255L34.5239 41.4287L32.2223 36.8255L27.6191 34.5239L32.2223 32.2223L34.5239 27.6191L36.8255 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 32.2223L69.0478 34.5239L64.4446 36.8255L62.143 41.4287L59.8415 36.8255L55.2383 34.5239L59.8415 32.2223L62.143 27.6191L64.4446 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 32.2223L96.6669 34.5239L92.0638 36.8255L89.7622 41.4287L87.4606 36.8255L82.8574 34.5239L87.4606 32.2223L89.7622 27.6191L92.0638 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 32.2223L124.286 34.5239L119.683 36.8255L117.381 41.4287L115.08 36.8255L110.477 34.5239L115.08 32.2223L117.381 27.6191L119.683 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 32.2223L151.905 34.5239L147.302 36.8255L145 41.4287L142.699 36.8255L138.096 34.5239L142.699 32.2223L145 27.6191L147.302 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 32.2223L179.523 34.5239L174.92 36.8255L172.619 41.4287L170.317 36.8255L165.714 34.5239L170.317 32.2223L172.619 27.6191L174.92 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 32.2223L207.143 34.5239L202.539 36.8255L200.238 41.4287L197.936 36.8255L193.333 34.5239L197.936 32.2223L200.238 27.6191L202.539 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 32.2223L234.762 34.5239L230.158 36.8255L227.857 41.4287L225.555 36.8255L220.952 34.5239L225.555 32.2223L227.857 27.6191L230.158 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 32.2223L262.381 34.5239L257.778 36.8255L255.476 41.4287L253.174 36.8255L248.571 34.5239L253.174 32.2223L255.476 27.6191L257.778 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 32.2223L290 34.5239L285.397 36.8255L283.095 41.4287L280.794 36.8255L276.19 34.5239L280.794 32.2223L283.095 27.6191L285.397 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 32.2223L317.619 34.5239L313.016 36.8255L310.714 41.4287L308.413 36.8255L303.81 34.5239L308.413 32.2223L310.714 27.6191L313.016 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 32.2223L345.238 34.5239L340.635 36.8255L338.333 41.4287L336.032 36.8255L331.429 34.5239L336.032 32.2223L338.333 27.6191L340.635 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 32.2223L372.857 34.5239L368.254 36.8255L365.953 41.4287L363.651 36.8255L359.048 34.5239L363.651 32.2223L365.953 27.6191L368.254 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 32.2223L400.477 34.5239L395.873 36.8255L393.572 41.4287L391.27 36.8255L386.667 34.5239L391.27 32.2223L393.572 27.6191L395.873 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 32.2223L428.096 34.5239L423.492 36.8255L421.191 41.4287L418.889 36.8255L414.286 34.5239L418.889 32.2223L421.191 27.6191L423.492 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 32.2223L455.714 34.5239L451.111 36.8255L448.809 41.4287L446.507 36.8255L441.904 34.5239L446.507 32.2223L448.809 27.6191L451.111 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 32.2223L483.333 34.5239L478.73 36.8255L476.428 41.4287L474.127 36.8255L469.523 34.5239L474.127 32.2223L476.428 27.6191L478.73 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 32.2223L510.952 34.5239L506.349 36.8255L504.047 41.4287L501.746 36.8255L497.143 34.5239L501.746 32.2223L504.047 27.6191L506.349 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 32.2223L538.571 34.5239L533.968 36.8255L531.666 41.4287L529.365 36.8255L524.762 34.5239L529.365 32.2223L531.666 27.6191L533.968 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 32.2223L566.19 34.5239L561.587 36.8255L559.286 41.4287L556.984 36.8255L552.381 34.5239L556.984 32.2223L559.286 27.6191L561.587 32.2223Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 59.8415L13.8095 62.143L9.20635 64.4446L6.90476 69.0478L4.60317 64.4446L0 62.143L4.60317 59.8415L6.90476 55.2383L9.20635 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 59.8415L41.4287 62.143L36.8255 64.4446L34.5239 69.0478L32.2223 64.4446L27.6191 62.143L32.2223 59.8415L34.5239 55.2383L36.8255 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 59.8415L69.0478 62.143L64.4446 64.4446L62.143 69.0478L59.8415 64.4446L55.2383 62.143L59.8415 59.8415L62.143 55.2383L64.4446 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 59.8415L96.6669 62.143L92.0638 64.4446L89.7622 69.0478L87.4606 64.4446L82.8574 62.143L87.4606 59.8415L89.7622 55.2383L92.0638 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 59.8415L124.286 62.143L119.683 64.4446L117.381 69.0478L115.08 64.4446L110.477 62.143L115.08 59.8415L117.381 55.2383L119.683 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 59.8415L151.905 62.143L147.302 64.4446L145 69.0478L142.699 64.4446L138.096 62.143L142.699 59.8415L145 55.2383L147.302 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 59.8415L179.523 62.143L174.92 64.4446L172.619 69.0478L170.317 64.4446L165.714 62.143L170.317 59.8415L172.619 55.2383L174.92 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 59.8415L207.143 62.143L202.539 64.4446L200.238 69.0478L197.936 64.4446L193.333 62.143L197.936 59.8415L200.238 55.2383L202.539 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 59.8415L234.762 62.143L230.158 64.4446L227.857 69.0478L225.555 64.4446L220.952 62.143L225.555 59.8415L227.857 55.2383L230.158 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 59.8415L262.381 62.143L257.778 64.4446L255.476 69.0478L253.174 64.4446L248.571 62.143L253.174 59.8415L255.476 55.2383L257.778 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip52_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 59.8415L290 62.143L285.397 64.4446L283.095 69.0478L280.794 64.4446L276.19 62.143L280.794 59.8415L283.095 55.2383L285.397 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 59.8415L317.619 62.143L313.016 64.4446L310.714 69.0478L308.413 64.4446L303.81 62.143L308.413 59.8415L310.714 55.2383L313.016 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip54_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 59.8415L345.238 62.143L340.635 64.4446L338.333 69.0478L336.032 64.4446L331.429 62.143L336.032 59.8415L338.333 55.2383L340.635 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 59.8415L372.857 62.143L368.254 64.4446L365.953 69.0478L363.651 64.4446L359.048 62.143L363.651 59.8415L365.953 55.2383L368.254 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip56_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 59.8415L400.477 62.143L395.873 64.4446L393.572 69.0478L391.27 64.4446L386.667 62.143L391.27 59.8415L393.572 55.2383L395.873 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 59.8415L428.096 62.143L423.492 64.4446L421.191 69.0478L418.889 64.4446L414.286 62.143L418.889 59.8415L421.191 55.2383L423.492 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip58_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 59.8415L455.714 62.143L451.111 64.4446L448.809 69.0478L446.507 64.4446L441.904 62.143L446.507 59.8415L448.809 55.2383L451.111 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 59.8415L483.333 62.143L478.73 64.4446L476.428 69.0478L474.127 64.4446L469.523 62.143L474.127 59.8415L476.428 55.2383L478.73 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip60_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 59.8415L510.952 62.143L506.349 64.4446L504.047 69.0478L501.746 64.4446L497.143 62.143L501.746 59.8415L504.047 55.2383L506.349 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 59.8415L538.571 62.143L533.968 64.4446L531.666 69.0478L529.365 64.4446L524.762 62.143L529.365 59.8415L531.666 55.2383L533.968 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip62_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 59.8415L566.19 62.143L561.587 64.4446L559.286 69.0478L556.984 64.4446L552.381 62.143L556.984 59.8415L559.286 55.2383L561.587 59.8415Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip63_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 87.4606L13.8095 89.7622L9.20635 92.0638L6.90476 96.6669L4.60317 92.0638L0 89.7622L4.60317 87.4606L6.90476 82.8574L9.20635 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip64_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 87.4606L41.4287 89.7622L36.8255 92.0638L34.5239 96.6669L32.2223 92.0638L27.6191 89.7622L32.2223 87.4606L34.5239 82.8574L36.8255 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip65_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 87.4606L69.0478 89.7622L64.4446 92.0638L62.143 96.6669L59.8415 92.0638L55.2383 89.7622L59.8415 87.4606L62.143 82.8574L64.4446 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip66_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 87.4606L96.6669 89.7622L92.0638 92.0638L89.7622 96.6669L87.4606 92.0638L82.8574 89.7622L87.4606 87.4606L89.7622 82.8574L92.0638 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip67_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 87.4606L124.286 89.7622L119.683 92.0638L117.381 96.6669L115.08 92.0638L110.477 89.7622L115.08 87.4606L117.381 82.8574L119.683 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip68_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 87.4606L151.905 89.7622L147.302 92.0638L145 96.6669L142.699 92.0638L138.096 89.7622L142.699 87.4606L145 82.8574L147.302 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip69_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 87.4606L179.524 89.7622L174.921 92.0638L172.62 96.6669L170.318 92.0638L165.715 89.7622L170.318 87.4606L172.62 82.8574L174.921 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip70_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 87.4606L207.144 89.7622L202.54 92.0638L200.239 96.6669L197.937 92.0638L193.334 89.7622L197.937 87.4606L200.239 82.8574L202.54 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 87.4606L234.762 89.7622L230.158 92.0638L227.857 96.6669L225.555 92.0638L220.952 89.7622L225.555 87.4606L227.857 82.8574L230.158 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip72_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 87.4606L262.381 89.7622L257.778 92.0638L255.476 96.6669L253.174 92.0638L248.571 89.7622L253.174 87.4606L255.476 82.8574L257.778 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip73_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 87.4606L290 89.7622L285.397 92.0638L283.095 96.6669L280.794 92.0638L276.19 89.7622L280.794 87.4606L283.095 82.8574L285.397 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip74_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 87.4606L317.619 89.7622L313.016 92.0638L310.714 96.6669L308.413 92.0638L303.81 89.7622L308.413 87.4606L310.714 82.8574L313.016 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip75_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 87.4606L345.238 89.7622L340.635 92.0638L338.333 96.6669L336.032 92.0638L331.429 89.7622L336.032 87.4606L338.333 82.8574L340.635 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip76_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 87.4606L372.857 89.7622L368.254 92.0638L365.953 96.6669L363.651 92.0638L359.048 89.7622L363.651 87.4606L365.953 82.8574L368.254 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip77_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 87.4606L400.476 89.7622L395.872 92.0638L393.571 96.6669L391.269 92.0638L386.666 89.7622L391.269 87.4606L393.571 82.8574L395.872 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip78_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 87.4606L428.095 89.7622L423.492 92.0638L421.19 96.6669L418.888 92.0638L414.285 89.7622L418.888 87.4606L421.19 82.8574L423.492 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip79_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 87.4606L455.714 89.7622L451.111 92.0638L448.809 96.6669L446.507 92.0638L441.904 89.7622L446.507 87.4606L448.809 82.8574L451.111 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip80_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 87.4606L483.333 89.7622L478.73 92.0638L476.428 96.6669L474.127 92.0638L469.523 89.7622L474.127 87.4606L476.428 82.8574L478.73 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip81_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 87.4606L510.952 89.7622L506.349 92.0638L504.047 96.6669L501.746 92.0638L497.143 89.7622L501.746 87.4606L504.047 82.8574L506.349 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip82_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 87.4606L538.571 89.7622L533.968 92.0638L531.666 96.6669L529.365 92.0638L524.762 89.7622L529.365 87.4606L531.666 82.8574L533.968 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip83_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 87.4606L566.19 89.7622L561.587 92.0638L559.286 96.6669L556.984 92.0638L552.381 89.7622L556.984 87.4606L559.286 82.8574L561.587 87.4606Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip84_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 115.08L13.8095 117.381L9.20635 119.683L6.90476 124.286L4.60317 119.683L0 117.381L4.60317 115.08L6.90476 110.477L9.20635 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip85_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 115.08L41.4287 117.381L36.8255 119.683L34.5239 124.286L32.2223 119.683L27.6191 117.381L32.2223 115.08L34.5239 110.477L36.8255 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip86_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 115.08L69.0478 117.381L64.4446 119.683L62.143 124.286L59.8415 119.683L55.2383 117.381L59.8415 115.08L62.143 110.477L64.4446 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip87_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 115.08L96.6669 117.381L92.0638 119.683L89.7622 124.286L87.4606 119.683L82.8574 117.381L87.4606 115.08L89.7622 110.477L92.0638 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip88_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 115.08L124.286 117.381L119.683 119.683L117.381 124.286L115.08 119.683L110.477 117.381L115.08 115.08L117.381 110.477L119.683 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip89_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 115.08L151.905 117.381L147.302 119.683L145 124.286L142.699 119.683L138.096 117.381L142.699 115.08L145 110.477L147.302 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip90_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 115.08L179.524 117.381L174.921 119.683L172.62 124.286L170.318 119.683L165.715 117.381L170.318 115.08L172.62 110.477L174.921 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip91_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 115.08L207.144 117.381L202.54 119.683L200.239 124.286L197.937 119.683L193.334 117.381L197.937 115.08L200.239 110.477L202.54 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip92_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 115.08L234.762 117.381L230.158 119.683L227.857 124.286L225.555 119.683L220.952 117.381L225.555 115.08L227.857 110.477L230.158 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip93_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 115.08L262.381 117.381L257.778 119.683L255.476 124.286L253.174 119.683L248.571 117.381L253.174 115.08L255.476 110.477L257.778 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip94_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 115.08L290 117.381L285.397 119.683L283.095 124.286L280.794 119.683L276.19 117.381L280.794 115.08L283.095 110.477L285.397 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip95_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 115.08L317.619 117.381L313.016 119.683L310.714 124.286L308.413 119.683L303.81 117.381L308.413 115.08L310.714 110.477L313.016 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip96_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 115.08L345.238 117.381L340.635 119.683L338.333 124.286L336.032 119.683L331.429 117.381L336.032 115.08L338.333 110.477L340.635 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip97_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 115.08L372.857 117.381L368.254 119.683L365.953 124.286L363.651 119.683L359.048 117.381L363.651 115.08L365.953 110.477L368.254 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip98_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 115.08L400.476 117.381L395.872 119.683L393.571 124.286L391.269 119.683L386.666 117.381L391.269 115.08L393.571 110.477L395.872 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip99_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 115.08L428.095 117.381L423.492 119.683L421.19 124.286L418.888 119.683L414.285 117.381L418.888 115.08L421.19 110.477L423.492 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip100_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 115.08L455.714 117.381L451.111 119.683L448.809 124.286L446.507 119.683L441.904 117.381L446.507 115.08L448.809 110.477L451.111 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip101_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 115.08L483.333 117.381L478.73 119.683L476.428 124.286L474.127 119.683L469.523 117.381L474.127 115.08L476.428 110.477L478.73 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip102_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 115.08L510.952 117.381L506.349 119.683L504.047 124.286L501.746 119.683L497.143 117.381L501.746 115.08L504.047 110.477L506.349 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip103_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 115.08L538.571 117.381L533.968 119.683L531.666 124.286L529.365 119.683L524.762 117.381L529.365 115.08L531.666 110.477L533.968 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip104_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 115.08L566.19 117.381L561.587 119.683L559.286 124.286L556.984 119.683L552.381 117.381L556.984 115.08L559.286 110.477L561.587 115.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip105_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 142.699L13.8095 145L9.20635 147.302L6.90476 151.905L4.60317 147.302L0 145L4.60317 142.699L6.90476 138.096L9.20635 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip106_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 142.699L41.4287 145L36.8255 147.302L34.5239 151.905L32.2223 147.302L27.6191 145L32.2223 142.699L34.5239 138.096L36.8255 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip107_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 142.699L69.0478 145L64.4446 147.302L62.143 151.905L59.8415 147.302L55.2383 145L59.8415 142.699L62.143 138.096L64.4446 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip108_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 142.699L96.6669 145L92.0638 147.302L89.7622 151.905L87.4606 147.302L82.8574 145L87.4606 142.699L89.7622 138.096L92.0638 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip109_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 142.699L124.286 145L119.683 147.302L117.381 151.905L115.08 147.302L110.477 145L115.08 142.699L117.381 138.096L119.683 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip110_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 142.699L151.905 145L147.302 147.302L145 151.905L142.699 147.302L138.096 145L142.699 142.699L145 138.096L147.302 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip111_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 142.699L179.524 145L174.921 147.302L172.62 151.905L170.318 147.302L165.715 145L170.318 142.699L172.62 138.096L174.921 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip112_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 142.699L207.144 145L202.54 147.302L200.239 151.905L197.937 147.302L193.334 145L197.937 142.699L200.239 138.096L202.54 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip113_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 142.699L234.762 145L230.158 147.302L227.857 151.905L225.555 147.302L220.952 145L225.555 142.699L227.857 138.096L230.158 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip114_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 142.699L262.381 145L257.778 147.302L255.476 151.905L253.174 147.302L248.571 145L253.174 142.699L255.476 138.096L257.778 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip115_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 142.699L290 145L285.397 147.302L283.095 151.905L280.794 147.302L276.19 145L280.794 142.699L283.095 138.096L285.397 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip116_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 142.699L317.619 145L313.016 147.302L310.714 151.905L308.413 147.302L303.81 145L308.413 142.699L310.714 138.096L313.016 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip117_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 142.699L345.238 145L340.635 147.302L338.333 151.905L336.032 147.302L331.429 145L336.032 142.699L338.333 138.096L340.635 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip118_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 142.699L372.857 145L368.254 147.302L365.953 151.905L363.651 147.302L359.048 145L363.651 142.699L365.953 138.096L368.254 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip119_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 142.699L400.476 145L395.872 147.302L393.571 151.905L391.269 147.302L386.666 145L391.269 142.699L393.571 138.096L395.872 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip120_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 142.699L428.095 145L423.492 147.302L421.19 151.905L418.888 147.302L414.285 145L418.888 142.699L421.19 138.096L423.492 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip121_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 142.699L455.714 145L451.111 147.302L448.809 151.905L446.507 147.302L441.904 145L446.507 142.699L448.809 138.096L451.111 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip122_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 142.699L483.333 145L478.73 147.302L476.428 151.905L474.127 147.302L469.523 145L474.127 142.699L476.428 138.096L478.73 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip123_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 142.699L510.952 145L506.349 147.302L504.047 151.905L501.746 147.302L497.143 145L501.746 142.699L504.047 138.096L506.349 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip124_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 142.699L538.571 145L533.968 147.302L531.666 151.905L529.365 147.302L524.762 145L529.365 142.699L531.666 138.096L533.968 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip125_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 142.699L566.19 145L561.587 147.302L559.286 151.905L556.984 147.302L552.381 145L556.984 142.699L559.286 138.096L561.587 142.699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip126_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 170.317L13.8095 172.619L9.20635 174.92L6.90476 179.523L4.60317 174.92L0 172.619L4.60317 170.317L6.90476 165.714L9.20635 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip127_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 170.317L41.4287 172.619L36.8255 174.92L34.5239 179.523L32.2223 174.92L27.6191 172.619L32.2223 170.317L34.5239 165.714L36.8255 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip128_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 170.317L69.0478 172.619L64.4446 174.92L62.143 179.523L59.8415 174.92L55.2383 172.619L59.8415 170.317L62.143 165.714L64.4446 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip129_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 170.317L96.6669 172.619L92.0638 174.92L89.7622 179.523L87.4606 174.92L82.8574 172.619L87.4606 170.317L89.7622 165.714L92.0638 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip130_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 170.317L124.286 172.619L119.683 174.92L117.381 179.523L115.08 174.92L110.477 172.619L115.08 170.317L117.381 165.714L119.683 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip131_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 170.317L151.905 172.619L147.302 174.92L145 179.523L142.699 174.92L138.096 172.619L142.699 170.317L145 165.714L147.302 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip132_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 170.317L179.524 172.619L174.921 174.92L172.62 179.523L170.318 174.92L165.715 172.619L170.318 170.317L172.62 165.714L174.921 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip133_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 170.317L207.144 172.619L202.54 174.92L200.239 179.523L197.937 174.92L193.334 172.619L197.937 170.317L200.239 165.714L202.54 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip134_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 170.317L234.762 172.619L230.158 174.92L227.857 179.523L225.555 174.92L220.952 172.619L225.555 170.317L227.857 165.714L230.158 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip135_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 170.317L262.381 172.619L257.778 174.92L255.476 179.523L253.174 174.92L248.571 172.619L253.174 170.317L255.476 165.714L257.778 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip136_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 170.317L290 172.619L285.397 174.92L283.095 179.523L280.794 174.92L276.19 172.619L280.794 170.317L283.095 165.714L285.397 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip137_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 170.317L317.619 172.619L313.016 174.92L310.714 179.523L308.413 174.92L303.81 172.619L308.413 170.317L310.714 165.714L313.016 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip138_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 170.317L345.238 172.619L340.635 174.92L338.333 179.523L336.032 174.92L331.429 172.619L336.032 170.317L338.333 165.714L340.635 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip139_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 170.317L372.857 172.619L368.254 174.92L365.953 179.523L363.651 174.92L359.048 172.619L363.651 170.317L365.953 165.714L368.254 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip140_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 170.317L400.476 172.619L395.872 174.92L393.571 179.523L391.269 174.92L386.666 172.619L391.269 170.317L393.571 165.714L395.872 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip141_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 170.317L428.095 172.619L423.492 174.92L421.19 179.523L418.888 174.92L414.285 172.619L418.888 170.317L421.19 165.714L423.492 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip142_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 170.317L455.714 172.619L451.111 174.92L448.809 179.523L446.507 174.92L441.904 172.619L446.507 170.317L448.809 165.714L451.111 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip143_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 170.317L483.333 172.619L478.73 174.92L476.428 179.523L474.127 174.92L469.523 172.619L474.127 170.317L476.428 165.714L478.73 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip144_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 170.317L510.952 172.619L506.349 174.92L504.047 179.523L501.746 174.92L497.143 172.619L501.746 170.317L504.047 165.714L506.349 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip145_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 170.317L538.571 172.619L533.968 174.92L531.666 179.523L529.365 174.92L524.762 172.619L529.365 170.317L531.666 165.714L533.968 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip146_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 170.317L566.19 172.619L561.587 174.92L559.286 179.523L556.984 174.92L552.381 172.619L556.984 170.317L559.286 165.714L561.587 170.317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip147_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 197.936L13.8095 200.238L9.20635 202.539L6.90476 207.143L4.60317 202.539L0 200.238L4.60317 197.936L6.90476 193.333L9.20635 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip148_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 197.936L41.4287 200.238L36.8255 202.539L34.5239 207.143L32.2223 202.539L27.6191 200.238L32.2223 197.936L34.5239 193.333L36.8255 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip149_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 197.936L69.0478 200.238L64.4446 202.539L62.143 207.143L59.8415 202.539L55.2383 200.238L59.8415 197.936L62.143 193.333L64.4446 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip150_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 197.936L96.6669 200.238L92.0638 202.539L89.7622 207.143L87.4606 202.539L82.8574 200.238L87.4606 197.936L89.7622 193.333L92.0638 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip151_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 197.936L124.286 200.238L119.683 202.539L117.381 207.143L115.08 202.539L110.477 200.238L115.08 197.936L117.381 193.333L119.683 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip152_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 197.936L151.905 200.238L147.302 202.539L145 207.143L142.699 202.539L138.096 200.238L142.699 197.936L145 193.333L147.302 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip153_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 197.936L179.524 200.238L174.921 202.539L172.62 207.143L170.318 202.539L165.715 200.238L170.318 197.936L172.62 193.333L174.921 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip154_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 197.936L207.144 200.238L202.54 202.539L200.239 207.143L197.937 202.539L193.334 200.238L197.937 197.936L200.239 193.333L202.54 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip155_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 197.936L234.762 200.238L230.158 202.539L227.857 207.143L225.555 202.539L220.952 200.238L225.555 197.936L227.857 193.333L230.158 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip156_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 197.936L262.381 200.238L257.778 202.539L255.476 207.143L253.174 202.539L248.571 200.238L253.174 197.936L255.476 193.333L257.778 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip157_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 197.936L290 200.238L285.397 202.539L283.095 207.143L280.794 202.539L276.19 200.238L280.794 197.936L283.095 193.333L285.397 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip158_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 197.936L317.619 200.238L313.016 202.539L310.714 207.143L308.413 202.539L303.81 200.238L308.413 197.936L310.714 193.333L313.016 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip159_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 197.936L345.238 200.238L340.635 202.539L338.333 207.143L336.032 202.539L331.429 200.238L336.032 197.936L338.333 193.333L340.635 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip160_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 197.936L372.857 200.238L368.254 202.539L365.953 207.143L363.651 202.539L359.048 200.238L363.651 197.936L365.953 193.333L368.254 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip161_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 197.936L400.476 200.238L395.872 202.539L393.571 207.143L391.269 202.539L386.666 200.238L391.269 197.936L393.571 193.333L395.872 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip162_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 197.936L428.095 200.238L423.492 202.539L421.19 207.143L418.888 202.539L414.285 200.238L418.888 197.936L421.19 193.333L423.492 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip163_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 197.936L455.714 200.238L451.111 202.539L448.809 207.143L446.507 202.539L441.904 200.238L446.507 197.936L448.809 193.333L451.111 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip164_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 197.936L483.333 200.238L478.73 202.539L476.428 207.143L474.127 202.539L469.523 200.238L474.127 197.936L476.428 193.333L478.73 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip165_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 197.936L510.952 200.238L506.349 202.539L504.047 207.143L501.746 202.539L497.143 200.238L501.746 197.936L504.047 193.333L506.349 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip166_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 197.936L538.571 200.238L533.968 202.539L531.666 207.143L529.365 202.539L524.762 200.238L529.365 197.936L531.666 193.333L533.968 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip167_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 197.936L566.19 200.238L561.587 202.539L559.286 207.143L556.984 202.539L552.381 200.238L556.984 197.936L559.286 193.333L561.587 197.936Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip168_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 225.555L13.8095 227.857L9.20635 230.158L6.90476 234.762L4.60317 230.158L0 227.857L4.60317 225.555L6.90476 220.952L9.20635 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip169_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 225.555L41.4287 227.857L36.8255 230.158L34.5239 234.762L32.2223 230.158L27.6191 227.857L32.2223 225.555L34.5239 220.952L36.8255 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip170_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 225.555L69.0478 227.857L64.4446 230.158L62.143 234.762L59.8415 230.158L55.2383 227.857L59.8415 225.555L62.143 220.952L64.4446 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip171_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 225.555L96.6669 227.857L92.0638 230.158L89.7622 234.762L87.4606 230.158L82.8574 227.857L87.4606 225.555L89.7622 220.952L92.0638 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip172_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 225.555L124.286 227.857L119.683 230.158L117.381 234.762L115.08 230.158L110.477 227.857L115.08 225.555L117.381 220.952L119.683 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip173_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 225.555L151.905 227.857L147.302 230.158L145 234.762L142.699 230.158L138.096 227.857L142.699 225.555L145 220.952L147.302 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip174_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 225.555L179.523 227.857L174.92 230.158L172.619 234.762L170.317 230.158L165.714 227.857L170.317 225.555L172.619 220.952L174.92 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip175_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 225.555L207.143 227.857L202.539 230.158L200.238 234.762L197.936 230.158L193.333 227.857L197.936 225.555L200.238 220.952L202.539 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip176_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 225.555L234.762 227.857L230.158 230.158L227.857 234.762L225.555 230.158L220.952 227.857L225.555 225.555L227.857 220.952L230.158 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip177_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 225.555L262.381 227.857L257.778 230.158L255.476 234.762L253.174 230.158L248.571 227.857L253.174 225.555L255.476 220.952L257.778 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip178_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 225.555L290 227.857L285.397 230.158L283.095 234.762L280.794 230.158L276.19 227.857L280.794 225.555L283.095 220.952L285.397 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip179_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 225.555L317.619 227.857L313.016 230.158L310.714 234.762L308.413 230.158L303.81 227.857L308.413 225.555L310.714 220.952L313.016 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip180_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 225.555L345.238 227.857L340.635 230.158L338.333 234.762L336.032 230.158L331.429 227.857L336.032 225.555L338.333 220.952L340.635 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip181_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 225.555L372.857 227.857L368.254 230.158L365.953 234.762L363.651 230.158L359.048 227.857L363.651 225.555L365.953 220.952L368.254 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip182_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 225.555L400.477 227.857L395.873 230.158L393.572 234.762L391.27 230.158L386.667 227.857L391.27 225.555L393.572 220.952L395.873 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip183_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 225.555L428.096 227.857L423.492 230.158L421.191 234.762L418.889 230.158L414.286 227.857L418.889 225.555L421.191 220.952L423.492 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip184_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 225.555L455.714 227.857L451.111 230.158L448.809 234.762L446.507 230.158L441.904 227.857L446.507 225.555L448.809 220.952L451.111 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip185_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 225.555L483.333 227.857L478.73 230.158L476.428 234.762L474.127 230.158L469.523 227.857L474.127 225.555L476.428 220.952L478.73 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip186_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 225.555L510.952 227.857L506.349 230.158L504.047 234.762L501.746 230.158L497.143 227.857L501.746 225.555L504.047 220.952L506.349 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip187_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 225.555L538.571 227.857L533.968 230.158L531.666 234.762L529.365 230.158L524.762 227.857L529.365 225.555L531.666 220.952L533.968 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip188_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 225.555L566.19 227.857L561.587 230.158L559.286 234.762L556.984 230.158L552.381 227.857L556.984 225.555L559.286 220.952L561.587 225.555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip189_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 253.174L13.8095 255.476L9.20635 257.778L6.90476 262.381L4.60317 257.778L0 255.476L4.60317 253.174L6.90476 248.571L9.20635 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip190_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 253.174L41.4287 255.476L36.8255 257.778L34.5239 262.381L32.2223 257.778L27.6191 255.476L32.2223 253.174L34.5239 248.571L36.8255 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip191_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 253.174L69.0478 255.476L64.4446 257.778L62.143 262.381L59.8415 257.778L55.2383 255.476L59.8415 253.174L62.143 248.571L64.4446 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip192_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 253.174L96.6669 255.476L92.0638 257.778L89.7622 262.381L87.4606 257.778L82.8574 255.476L87.4606 253.174L89.7622 248.571L92.0638 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip193_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 253.174L124.286 255.476L119.683 257.778L117.381 262.381L115.08 257.778L110.477 255.476L115.08 253.174L117.381 248.571L119.683 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip194_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 253.174L151.905 255.476L147.302 257.778L145 262.381L142.699 257.778L138.096 255.476L142.699 253.174L145 248.571L147.302 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip195_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 253.174L179.523 255.476L174.92 257.778L172.619 262.381L170.317 257.778L165.714 255.476L170.317 253.174L172.619 248.571L174.92 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip196_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 253.174L207.143 255.476L202.539 257.778L200.238 262.381L197.936 257.778L193.333 255.476L197.936 253.174L200.238 248.571L202.539 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip197_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 253.174L234.762 255.476L230.158 257.778L227.857 262.381L225.555 257.778L220.952 255.476L225.555 253.174L227.857 248.571L230.158 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip198_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 253.174L262.381 255.476L257.778 257.778L255.476 262.381L253.174 257.778L248.571 255.476L253.174 253.174L255.476 248.571L257.778 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip199_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 253.174L290 255.476L285.397 257.778L283.095 262.381L280.794 257.778L276.19 255.476L280.794 253.174L283.095 248.571L285.397 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip200_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 253.174L317.619 255.476L313.016 257.778L310.714 262.381L308.413 257.778L303.81 255.476L308.413 253.174L310.714 248.571L313.016 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip201_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 253.174L345.238 255.476L340.635 257.778L338.333 262.381L336.032 257.778L331.429 255.476L336.032 253.174L338.333 248.571L340.635 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip202_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 253.174L372.857 255.476L368.254 257.778L365.953 262.381L363.651 257.778L359.048 255.476L363.651 253.174L365.953 248.571L368.254 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip203_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 253.174L400.477 255.476L395.873 257.778L393.572 262.381L391.27 257.778L386.667 255.476L391.27 253.174L393.572 248.571L395.873 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip204_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 253.174L428.096 255.476L423.492 257.778L421.191 262.381L418.889 257.778L414.286 255.476L418.889 253.174L421.191 248.571L423.492 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip205_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 253.174L455.714 255.476L451.111 257.778L448.809 262.381L446.507 257.778L441.904 255.476L446.507 253.174L448.809 248.571L451.111 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip206_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 253.174L483.333 255.476L478.73 257.778L476.428 262.381L474.127 257.778L469.523 255.476L474.127 253.174L476.428 248.571L478.73 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip207_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 253.174L510.952 255.476L506.349 257.778L504.047 262.381L501.746 257.778L497.143 255.476L501.746 253.174L504.047 248.571L506.349 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip208_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 253.174L538.571 255.476L533.968 257.778L531.666 262.381L529.365 257.778L524.762 255.476L529.365 253.174L531.666 248.571L533.968 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip209_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 253.174L566.19 255.476L561.587 257.778L559.286 262.381L556.984 257.778L552.381 255.476L556.984 253.174L559.286 248.571L561.587 253.174Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip210_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 280.794L13.8095 283.095L9.20635 285.397L6.90476 290L4.60317 285.397L0 283.095L4.60317 280.794L6.90476 276.19L9.20635 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip211_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 280.794L41.4287 283.095L36.8255 285.397L34.5239 290L32.2223 285.397L27.6191 283.095L32.2223 280.794L34.5239 276.19L36.8255 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip212_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 280.794L69.0478 283.095L64.4446 285.397L62.143 290L59.8415 285.397L55.2383 283.095L59.8415 280.794L62.143 276.19L64.4446 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip213_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 280.794L96.6669 283.095L92.0638 285.397L89.7622 290L87.4606 285.397L82.8574 283.095L87.4606 280.794L89.7622 276.19L92.0638 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip214_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 280.794L124.286 283.095L119.683 285.397L117.381 290L115.08 285.397L110.477 283.095L115.08 280.794L117.381 276.19L119.683 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip215_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 280.794L151.905 283.095L147.302 285.397L145 290L142.699 285.397L138.096 283.095L142.699 280.794L145 276.19L147.302 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip216_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 280.794L179.523 283.095L174.92 285.397L172.619 290L170.317 285.397L165.714 283.095L170.317 280.794L172.619 276.19L174.92 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip217_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 280.794L207.143 283.095L202.539 285.397L200.238 290L197.936 285.397L193.333 283.095L197.936 280.794L200.238 276.19L202.539 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip218_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 280.794L234.762 283.095L230.158 285.397L227.857 290L225.555 285.397L220.952 283.095L225.555 280.794L227.857 276.19L230.158 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip219_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 280.794L262.381 283.095L257.778 285.397L255.476 290L253.174 285.397L248.571 283.095L253.174 280.794L255.476 276.19L257.778 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip220_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 280.794L290 283.095L285.397 285.397L283.095 290L280.794 285.397L276.19 283.095L280.794 280.794L283.095 276.19L285.397 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip221_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 280.794L317.619 283.095L313.016 285.397L310.714 290L308.413 285.397L303.81 283.095L308.413 280.794L310.714 276.19L313.016 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip222_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 280.794L345.238 283.095L340.635 285.397L338.333 290L336.032 285.397L331.429 283.095L336.032 280.794L338.333 276.19L340.635 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip223_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 280.794L372.857 283.095L368.254 285.397L365.953 290L363.651 285.397L359.048 283.095L363.651 280.794L365.953 276.19L368.254 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip224_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 280.794L400.477 283.095L395.873 285.397L393.572 290L391.27 285.397L386.667 283.095L391.27 280.794L393.572 276.19L395.873 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip225_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 280.794L428.096 283.095L423.492 285.397L421.191 290L418.889 285.397L414.286 283.095L418.889 280.794L421.191 276.19L423.492 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip226_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 280.794L455.714 283.095L451.111 285.397L448.809 290L446.507 285.397L441.904 283.095L446.507 280.794L448.809 276.19L451.111 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip227_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 280.794L483.333 283.095L478.73 285.397L476.428 290L474.127 285.397L469.523 283.095L474.127 280.794L476.428 276.19L478.73 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip228_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 280.794L510.952 283.095L506.349 285.397L504.047 290L501.746 285.397L497.143 283.095L501.746 280.794L504.047 276.19L506.349 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip229_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 280.794L538.571 283.095L533.968 285.397L531.666 290L529.365 285.397L524.762 283.095L529.365 280.794L531.666 276.19L533.968 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip230_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 280.794L566.19 283.095L561.587 285.397L559.286 290L556.984 285.397L552.381 283.095L556.984 280.794L559.286 276.19L561.587 280.794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip231_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 308.413L13.8095 310.714L9.20635 313.016L6.90476 317.619L4.60317 313.016L0 310.714L4.60317 308.413L6.90476 303.81L9.20635 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip232_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 308.413L41.4287 310.714L36.8255 313.016L34.5239 317.619L32.2223 313.016L27.6191 310.714L32.2223 308.413L34.5239 303.81L36.8255 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip233_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 308.413L69.0478 310.714L64.4446 313.016L62.143 317.619L59.8415 313.016L55.2383 310.714L59.8415 308.413L62.143 303.81L64.4446 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip234_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 308.413L96.6669 310.714L92.0638 313.016L89.7622 317.619L87.4606 313.016L82.8574 310.714L87.4606 308.413L89.7622 303.81L92.0638 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip235_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 308.413L124.286 310.714L119.683 313.016L117.381 317.619L115.08 313.016L110.477 310.714L115.08 308.413L117.381 303.81L119.683 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip236_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 308.413L151.905 310.714L147.302 313.016L145 317.619L142.699 313.016L138.096 310.714L142.699 308.413L145 303.81L147.302 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip237_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 308.413L179.523 310.714L174.92 313.016L172.619 317.619L170.317 313.016L165.714 310.714L170.317 308.413L172.619 303.81L174.92 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip238_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 308.413L207.143 310.714L202.539 313.016L200.238 317.619L197.936 313.016L193.333 310.714L197.936 308.413L200.238 303.81L202.539 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip239_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 308.413L234.762 310.714L230.158 313.016L227.857 317.619L225.555 313.016L220.952 310.714L225.555 308.413L227.857 303.81L230.158 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip240_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 308.413L262.381 310.714L257.778 313.016L255.476 317.619L253.174 313.016L248.571 310.714L253.174 308.413L255.476 303.81L257.778 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip241_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 308.413L290 310.714L285.397 313.016L283.095 317.619L280.794 313.016L276.19 310.714L280.794 308.413L283.095 303.81L285.397 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip242_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 308.413L317.619 310.714L313.016 313.016L310.714 317.619L308.413 313.016L303.81 310.714L308.413 308.413L310.714 303.81L313.016 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip243_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 308.413L345.238 310.714L340.635 313.016L338.333 317.619L336.032 313.016L331.429 310.714L336.032 308.413L338.333 303.81L340.635 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip244_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 308.413L372.857 310.714L368.254 313.016L365.953 317.619L363.651 313.016L359.048 310.714L363.651 308.413L365.953 303.81L368.254 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip245_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 308.413L400.477 310.714L395.873 313.016L393.572 317.619L391.27 313.016L386.667 310.714L391.27 308.413L393.572 303.81L395.873 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip246_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 308.413L428.096 310.714L423.492 313.016L421.191 317.619L418.889 313.016L414.286 310.714L418.889 308.413L421.191 303.81L423.492 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip247_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 308.413L455.714 310.714L451.111 313.016L448.809 317.619L446.507 313.016L441.904 310.714L446.507 308.413L448.809 303.81L451.111 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip248_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 308.413L483.333 310.714L478.73 313.016L476.428 317.619L474.127 313.016L469.523 310.714L474.127 308.413L476.428 303.81L478.73 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip249_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 308.413L510.952 310.714L506.349 313.016L504.047 317.619L501.746 313.016L497.143 310.714L501.746 308.413L504.047 303.81L506.349 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip250_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 308.413L538.571 310.714L533.968 313.016L531.666 317.619L529.365 313.016L524.762 310.714L529.365 308.413L531.666 303.81L533.968 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip251_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 308.413L566.19 310.714L561.587 313.016L559.286 317.619L556.984 313.016L552.381 310.714L556.984 308.413L559.286 303.81L561.587 308.413Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip252_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 336.032L13.8095 338.333L9.20635 340.635L6.90476 345.238L4.60317 340.635L0 338.333L4.60317 336.032L6.90476 331.429L9.20635 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip253_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 336.032L41.4287 338.333L36.8255 340.635L34.5239 345.238L32.2223 340.635L27.6191 338.333L32.2223 336.032L34.5239 331.429L36.8255 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip254_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 336.032L69.0478 338.333L64.4446 340.635L62.143 345.238L59.8415 340.635L55.2383 338.333L59.8415 336.032L62.143 331.429L64.4446 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip255_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 336.032L96.6669 338.333L92.0638 340.635L89.7622 345.238L87.4606 340.635L82.8574 338.333L87.4606 336.032L89.7622 331.429L92.0638 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip256_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 336.032L124.286 338.333L119.683 340.635L117.381 345.238L115.08 340.635L110.477 338.333L115.08 336.032L117.381 331.429L119.683 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip257_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 336.032L151.905 338.333L147.302 340.635L145 345.238L142.699 340.635L138.096 338.333L142.699 336.032L145 331.429L147.302 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip258_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 336.032L179.523 338.333L174.92 340.635L172.619 345.238L170.317 340.635L165.714 338.333L170.317 336.032L172.619 331.429L174.92 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip259_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 336.032L207.143 338.333L202.539 340.635L200.238 345.238L197.936 340.635L193.333 338.333L197.936 336.032L200.238 331.429L202.539 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip260_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 336.032L234.762 338.333L230.158 340.635L227.857 345.238L225.555 340.635L220.952 338.333L225.555 336.032L227.857 331.429L230.158 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip261_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 336.032L262.381 338.333L257.778 340.635L255.476 345.238L253.174 340.635L248.571 338.333L253.174 336.032L255.476 331.429L257.778 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip262_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 336.032L290 338.333L285.397 340.635L283.095 345.238L280.794 340.635L276.19 338.333L280.794 336.032L283.095 331.429L285.397 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip263_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 336.032L317.619 338.333L313.016 340.635L310.714 345.238L308.413 340.635L303.81 338.333L308.413 336.032L310.714 331.429L313.016 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip264_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 336.032L345.238 338.333L340.635 340.635L338.333 345.238L336.032 340.635L331.429 338.333L336.032 336.032L338.333 331.429L340.635 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip265_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 336.032L372.857 338.333L368.254 340.635L365.953 345.238L363.651 340.635L359.048 338.333L363.651 336.032L365.953 331.429L368.254 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip266_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 336.032L400.477 338.333L395.873 340.635L393.572 345.238L391.27 340.635L386.667 338.333L391.27 336.032L393.572 331.429L395.873 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip267_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 336.032L428.096 338.333L423.492 340.635L421.191 345.238L418.889 340.635L414.286 338.333L418.889 336.032L421.191 331.429L423.492 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip268_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 336.032L455.714 338.333L451.111 340.635L448.809 345.238L446.507 340.635L441.904 338.333L446.507 336.032L448.809 331.429L451.111 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip269_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 336.032L483.333 338.333L478.73 340.635L476.428 345.238L474.127 340.635L469.523 338.333L474.127 336.032L476.428 331.429L478.73 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip270_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 336.032L510.952 338.333L506.349 340.635L504.047 345.238L501.746 340.635L497.143 338.333L501.746 336.032L504.047 331.429L506.349 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip271_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 336.032L538.571 338.333L533.968 340.635L531.666 345.238L529.365 340.635L524.762 338.333L529.365 336.032L531.666 331.429L533.968 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip272_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 336.032L566.19 338.333L561.587 340.635L559.286 345.238L556.984 340.635L552.381 338.333L556.984 336.032L559.286 331.429L561.587 336.032Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip273_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 363.651L13.8095 365.953L9.20635 368.254L6.90476 372.857L4.60317 368.254L0 365.953L4.60317 363.651L6.90476 359.048L9.20635 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip274_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 363.651L41.4287 365.953L36.8255 368.254L34.5239 372.857L32.2223 368.254L27.6191 365.953L32.2223 363.651L34.5239 359.048L36.8255 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip275_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 363.651L69.0478 365.953L64.4446 368.254L62.143 372.857L59.8415 368.254L55.2383 365.953L59.8415 363.651L62.143 359.048L64.4446 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip276_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 363.651L96.6669 365.953L92.0638 368.254L89.7622 372.857L87.4606 368.254L82.8574 365.953L87.4606 363.651L89.7622 359.048L92.0638 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip277_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 363.651L124.286 365.953L119.683 368.254L117.381 372.857L115.08 368.254L110.477 365.953L115.08 363.651L117.381 359.048L119.683 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip278_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 363.651L151.905 365.953L147.302 368.254L145 372.857L142.699 368.254L138.096 365.953L142.699 363.651L145 359.048L147.302 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip279_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 363.651L179.524 365.953L174.921 368.254L172.62 372.857L170.318 368.254L165.715 365.953L170.318 363.651L172.62 359.048L174.921 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip280_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 363.651L207.144 365.953L202.54 368.254L200.239 372.857L197.937 368.254L193.334 365.953L197.937 363.651L200.239 359.048L202.54 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip281_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 363.651L234.762 365.953L230.158 368.254L227.857 372.857L225.555 368.254L220.952 365.953L225.555 363.651L227.857 359.048L230.158 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip282_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 363.651L262.381 365.953L257.778 368.254L255.476 372.857L253.174 368.254L248.571 365.953L253.174 363.651L255.476 359.048L257.778 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip283_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 363.651L290 365.953L285.397 368.254L283.095 372.857L280.794 368.254L276.19 365.953L280.794 363.651L283.095 359.048L285.397 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip284_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 363.651L317.619 365.953L313.016 368.254L310.714 372.857L308.413 368.254L303.81 365.953L308.413 363.651L310.714 359.048L313.016 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip285_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 363.651L345.238 365.953L340.635 368.254L338.333 372.857L336.032 368.254L331.429 365.953L336.032 363.651L338.333 359.048L340.635 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip286_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 363.651L372.857 365.953L368.254 368.254L365.953 372.857L363.651 368.254L359.048 365.953L363.651 363.651L365.953 359.048L368.254 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip287_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 363.651L400.476 365.953L395.872 368.254L393.571 372.857L391.269 368.254L386.666 365.953L391.269 363.651L393.571 359.048L395.872 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip288_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 363.651L428.095 365.953L423.492 368.254L421.19 372.857L418.888 368.254L414.285 365.953L418.888 363.651L421.19 359.048L423.492 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip289_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 363.651L455.714 365.953L451.111 368.254L448.809 372.857L446.507 368.254L441.904 365.953L446.507 363.651L448.809 359.048L451.111 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip290_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 363.651L483.333 365.953L478.73 368.254L476.428 372.857L474.127 368.254L469.523 365.953L474.127 363.651L476.428 359.048L478.73 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip291_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 363.651L510.952 365.953L506.349 368.254L504.047 372.857L501.746 368.254L497.143 365.953L501.746 363.651L504.047 359.048L506.349 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip292_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 363.651L538.571 365.953L533.968 368.254L531.666 372.857L529.365 368.254L524.762 365.953L529.365 363.651L531.666 359.048L533.968 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip293_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 363.651L566.19 365.953L561.587 368.254L559.286 372.857L556.984 368.254L552.381 365.953L556.984 363.651L559.286 359.048L561.587 363.651Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip294_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 391.27L13.8095 393.572L9.20635 395.873L6.90476 400.477L4.60317 395.873L0 393.572L4.60317 391.27L6.90476 386.667L9.20635 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip295_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 391.27L41.4287 393.572L36.8255 395.873L34.5239 400.477L32.2223 395.873L27.6191 393.572L32.2223 391.27L34.5239 386.667L36.8255 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip296_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 391.27L69.0478 393.572L64.4446 395.873L62.143 400.477L59.8415 395.873L55.2383 393.572L59.8415 391.27L62.143 386.667L64.4446 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip297_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 391.27L96.6669 393.572L92.0638 395.873L89.7622 400.477L87.4606 395.873L82.8574 393.572L87.4606 391.27L89.7622 386.667L92.0638 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip298_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 391.27L124.286 393.572L119.683 395.873L117.381 400.477L115.08 395.873L110.477 393.572L115.08 391.27L117.381 386.667L119.683 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip299_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 391.27L151.905 393.572L147.302 395.873L145 400.477L142.699 395.873L138.096 393.572L142.699 391.27L145 386.667L147.302 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip300_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 391.27L179.524 393.572L174.921 395.873L172.62 400.477L170.318 395.873L165.715 393.572L170.318 391.27L172.62 386.667L174.921 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip301_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 391.27L207.144 393.572L202.54 395.873L200.239 400.477L197.937 395.873L193.334 393.572L197.937 391.27L200.239 386.667L202.54 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip302_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 391.27L234.762 393.572L230.158 395.873L227.857 400.477L225.555 395.873L220.952 393.572L225.555 391.27L227.857 386.667L230.158 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip303_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 391.27L262.381 393.572L257.778 395.873L255.476 400.477L253.174 395.873L248.571 393.572L253.174 391.27L255.476 386.667L257.778 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip304_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 391.27L290 393.572L285.397 395.873L283.095 400.477L280.794 395.873L276.19 393.572L280.794 391.27L283.095 386.667L285.397 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip305_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 391.27L317.619 393.572L313.016 395.873L310.714 400.477L308.413 395.873L303.81 393.572L308.413 391.27L310.714 386.667L313.016 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip306_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 391.27L345.238 393.572L340.635 395.873L338.333 400.477L336.032 395.873L331.429 393.572L336.032 391.27L338.333 386.667L340.635 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip307_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 391.27L372.857 393.572L368.254 395.873L365.953 400.477L363.651 395.873L359.048 393.572L363.651 391.27L365.953 386.667L368.254 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip308_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 391.27L400.476 393.572L395.872 395.873L393.571 400.477L391.269 395.873L386.666 393.572L391.269 391.27L393.571 386.667L395.872 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip309_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 391.27L428.095 393.572L423.492 395.873L421.19 400.477L418.888 395.873L414.285 393.572L418.888 391.27L421.19 386.667L423.492 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip310_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 391.27L455.714 393.572L451.111 395.873L448.809 400.477L446.507 395.873L441.904 393.572L446.507 391.27L448.809 386.667L451.111 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip311_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 391.27L483.333 393.572L478.73 395.873L476.428 400.477L474.127 395.873L469.523 393.572L474.127 391.27L476.428 386.667L478.73 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip312_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 391.27L510.952 393.572L506.349 395.873L504.047 400.477L501.746 395.873L497.143 393.572L501.746 391.27L504.047 386.667L506.349 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip313_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 391.27L538.571 393.572L533.968 395.873L531.666 400.477L529.365 395.873L524.762 393.572L529.365 391.27L531.666 386.667L533.968 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip314_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 391.27L566.19 393.572L561.587 395.873L559.286 400.477L556.984 395.873L552.381 393.572L556.984 391.27L559.286 386.667L561.587 391.27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip315_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 418.889L13.8095 421.191L9.20635 423.492L6.90476 428.096L4.60317 423.492L0 421.191L4.60317 418.889L6.90476 414.286L9.20635 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip316_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 418.889L41.4287 421.191L36.8255 423.492L34.5239 428.096L32.2223 423.492L27.6191 421.191L32.2223 418.889L34.5239 414.286L36.8255 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip317_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 418.889L69.0478 421.191L64.4446 423.492L62.143 428.096L59.8415 423.492L55.2383 421.191L59.8415 418.889L62.143 414.286L64.4446 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip318_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 418.889L96.6669 421.191L92.0638 423.492L89.7622 428.096L87.4606 423.492L82.8574 421.191L87.4606 418.889L89.7622 414.286L92.0638 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip319_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 418.889L124.286 421.191L119.683 423.492L117.381 428.096L115.08 423.492L110.477 421.191L115.08 418.889L117.381 414.286L119.683 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip320_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 418.889L151.905 421.191L147.302 423.492L145 428.096L142.699 423.492L138.096 421.191L142.699 418.889L145 414.286L147.302 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip321_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 418.889L179.524 421.191L174.921 423.492L172.62 428.096L170.318 423.492L165.715 421.191L170.318 418.889L172.62 414.286L174.921 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip322_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 418.889L207.144 421.191L202.54 423.492L200.239 428.096L197.937 423.492L193.334 421.191L197.937 418.889L200.239 414.286L202.54 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip323_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 418.889L234.762 421.191L230.158 423.492L227.857 428.096L225.555 423.492L220.952 421.191L225.555 418.889L227.857 414.286L230.158 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip324_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 418.889L262.381 421.191L257.778 423.492L255.476 428.096L253.174 423.492L248.571 421.191L253.174 418.889L255.476 414.286L257.778 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip325_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 418.889L290 421.191L285.397 423.492L283.095 428.096L280.794 423.492L276.19 421.191L280.794 418.889L283.095 414.286L285.397 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip326_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 418.889L317.619 421.191L313.016 423.492L310.714 428.096L308.413 423.492L303.81 421.191L308.413 418.889L310.714 414.286L313.016 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip327_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 418.889L345.238 421.191L340.635 423.492L338.333 428.096L336.032 423.492L331.429 421.191L336.032 418.889L338.333 414.286L340.635 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip328_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 418.889L372.857 421.191L368.254 423.492L365.953 428.096L363.651 423.492L359.048 421.191L363.651 418.889L365.953 414.286L368.254 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip329_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 418.889L400.476 421.191L395.872 423.492L393.571 428.096L391.269 423.492L386.666 421.191L391.269 418.889L393.571 414.286L395.872 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip330_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 418.889L428.095 421.191L423.492 423.492L421.19 428.096L418.888 423.492L414.285 421.191L418.888 418.889L421.19 414.286L423.492 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip331_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 418.889L455.714 421.191L451.111 423.492L448.809 428.096L446.507 423.492L441.904 421.191L446.507 418.889L448.809 414.286L451.111 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip332_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 418.889L483.333 421.191L478.73 423.492L476.428 428.096L474.127 423.492L469.523 421.191L474.127 418.889L476.428 414.286L478.73 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip333_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 418.889L510.952 421.191L506.349 423.492L504.047 428.096L501.746 423.492L497.143 421.191L501.746 418.889L504.047 414.286L506.349 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip334_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 418.889L538.571 421.191L533.968 423.492L531.666 428.096L529.365 423.492L524.762 421.191L529.365 418.889L531.666 414.286L533.968 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip335_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 418.889L566.19 421.191L561.587 423.492L559.286 428.096L556.984 423.492L552.381 421.191L556.984 418.889L559.286 414.286L561.587 418.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip336_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 446.507L13.8095 448.809L9.20635 451.111L6.90476 455.714L4.60317 451.111L0 448.809L4.60317 446.507L6.90476 441.904L9.20635 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip337_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 446.507L41.4287 448.809L36.8255 451.111L34.5239 455.714L32.2223 451.111L27.6191 448.809L32.2223 446.507L34.5239 441.904L36.8255 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip338_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 446.507L69.0478 448.809L64.4446 451.111L62.143 455.714L59.8415 451.111L55.2383 448.809L59.8415 446.507L62.143 441.904L64.4446 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip339_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 446.507L96.6669 448.809L92.0638 451.111L89.7622 455.714L87.4606 451.111L82.8574 448.809L87.4606 446.507L89.7622 441.904L92.0638 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip340_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 446.507L124.286 448.809L119.683 451.111L117.381 455.714L115.08 451.111L110.477 448.809L115.08 446.507L117.381 441.904L119.683 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip341_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 446.507L151.905 448.809L147.302 451.111L145 455.714L142.699 451.111L138.096 448.809L142.699 446.507L145 441.904L147.302 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip342_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 446.507L179.524 448.809L174.921 451.111L172.62 455.714L170.318 451.111L165.715 448.809L170.318 446.507L172.62 441.904L174.921 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip343_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 446.507L207.144 448.809L202.54 451.111L200.239 455.714L197.937 451.111L193.334 448.809L197.937 446.507L200.239 441.904L202.54 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip344_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 446.507L234.762 448.809L230.158 451.111L227.857 455.714L225.555 451.111L220.952 448.809L225.555 446.507L227.857 441.904L230.158 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip345_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 446.507L262.381 448.809L257.778 451.111L255.476 455.714L253.174 451.111L248.571 448.809L253.174 446.507L255.476 441.904L257.778 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip346_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 446.507L290 448.809L285.397 451.111L283.095 455.714L280.794 451.111L276.19 448.809L280.794 446.507L283.095 441.904L285.397 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip347_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 446.507L317.619 448.809L313.016 451.111L310.714 455.714L308.413 451.111L303.81 448.809L308.413 446.507L310.714 441.904L313.016 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip348_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 446.507L345.238 448.809L340.635 451.111L338.333 455.714L336.032 451.111L331.429 448.809L336.032 446.507L338.333 441.904L340.635 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip349_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 446.507L372.857 448.809L368.254 451.111L365.953 455.714L363.651 451.111L359.048 448.809L363.651 446.507L365.953 441.904L368.254 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip350_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 446.507L400.476 448.809L395.872 451.111L393.571 455.714L391.269 451.111L386.666 448.809L391.269 446.507L393.571 441.904L395.872 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip351_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 446.507L428.095 448.809L423.492 451.111L421.19 455.714L418.888 451.111L414.285 448.809L418.888 446.507L421.19 441.904L423.492 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip352_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 446.507L455.714 448.809L451.111 451.111L448.809 455.714L446.507 451.111L441.904 448.809L446.507 446.507L448.809 441.904L451.111 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip353_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 446.507L483.333 448.809L478.73 451.111L476.428 455.714L474.127 451.111L469.523 448.809L474.127 446.507L476.428 441.904L478.73 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip354_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 446.507L510.952 448.809L506.349 451.111L504.047 455.714L501.746 451.111L497.143 448.809L501.746 446.507L504.047 441.904L506.349 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip355_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 446.507L538.571 448.809L533.968 451.111L531.666 455.714L529.365 451.111L524.762 448.809L529.365 446.507L531.666 441.904L533.968 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip356_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 446.507L566.19 448.809L561.587 451.111L559.286 455.714L556.984 451.111L552.381 448.809L556.984 446.507L559.286 441.904L561.587 446.507Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip357_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 474.127L13.8095 476.428L9.20635 478.73L6.90476 483.333L4.60317 478.73L0 476.428L4.60317 474.127L6.90476 469.523L9.20635 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip358_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 474.127L41.4287 476.428L36.8255 478.73L34.5239 483.333L32.2223 478.73L27.6191 476.428L32.2223 474.127L34.5239 469.523L36.8255 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip359_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 474.127L69.0478 476.428L64.4446 478.73L62.143 483.333L59.8415 478.73L55.2383 476.428L59.8415 474.127L62.143 469.523L64.4446 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip360_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 474.127L96.6669 476.428L92.0638 478.73L89.7622 483.333L87.4606 478.73L82.8574 476.428L87.4606 474.127L89.7622 469.523L92.0638 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip361_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 474.127L124.286 476.428L119.683 478.73L117.381 483.333L115.08 478.73L110.477 476.428L115.08 474.127L117.381 469.523L119.683 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip362_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 474.127L151.905 476.428L147.302 478.73L145 483.333L142.699 478.73L138.096 476.428L142.699 474.127L145 469.523L147.302 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip363_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 474.127L179.524 476.428L174.921 478.73L172.62 483.333L170.318 478.73L165.715 476.428L170.318 474.127L172.62 469.523L174.921 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip364_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 474.127L207.144 476.428L202.54 478.73L200.239 483.333L197.937 478.73L193.334 476.428L197.937 474.127L200.239 469.523L202.54 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip365_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 474.127L234.762 476.428L230.158 478.73L227.857 483.333L225.555 478.73L220.952 476.428L225.555 474.127L227.857 469.523L230.158 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip366_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 474.127L262.381 476.428L257.778 478.73L255.476 483.333L253.174 478.73L248.571 476.428L253.174 474.127L255.476 469.523L257.778 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip367_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 474.127L290 476.428L285.397 478.73L283.095 483.333L280.794 478.73L276.19 476.428L280.794 474.127L283.095 469.523L285.397 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip368_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 474.127L317.619 476.428L313.016 478.73L310.714 483.333L308.413 478.73L303.81 476.428L308.413 474.127L310.714 469.523L313.016 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip369_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 474.127L345.238 476.428L340.635 478.73L338.333 483.333L336.032 478.73L331.429 476.428L336.032 474.127L338.333 469.523L340.635 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip370_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 474.127L372.857 476.428L368.254 478.73L365.953 483.333L363.651 478.73L359.048 476.428L363.651 474.127L365.953 469.523L368.254 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip371_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 474.127L400.476 476.428L395.872 478.73L393.571 483.333L391.269 478.73L386.666 476.428L391.269 474.127L393.571 469.523L395.872 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip372_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 474.127L428.095 476.428L423.492 478.73L421.19 483.333L418.888 478.73L414.285 476.428L418.888 474.127L421.19 469.523L423.492 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip373_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 474.127L455.714 476.428L451.111 478.73L448.809 483.333L446.507 478.73L441.904 476.428L446.507 474.127L448.809 469.523L451.111 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip374_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 474.127L483.333 476.428L478.73 478.73L476.428 483.333L474.127 478.73L469.523 476.428L474.127 474.127L476.428 469.523L478.73 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip375_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 474.127L510.952 476.428L506.349 478.73L504.047 483.333L501.746 478.73L497.143 476.428L501.746 474.127L504.047 469.523L506.349 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip376_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 474.127L538.571 476.428L533.968 478.73L531.666 483.333L529.365 478.73L524.762 476.428L529.365 474.127L531.666 469.523L533.968 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip377_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 474.127L566.19 476.428L561.587 478.73L559.286 483.333L556.984 478.73L552.381 476.428L556.984 474.127L559.286 469.523L561.587 474.127Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip378_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 501.746L13.8095 504.047L9.20635 506.349L6.90476 510.952L4.60317 506.349L0 504.047L4.60317 501.746L6.90476 497.143L9.20635 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip379_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 501.746L41.4287 504.047L36.8255 506.349L34.5239 510.952L32.2223 506.349L27.6191 504.047L32.2223 501.746L34.5239 497.143L36.8255 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip380_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 501.746L69.0478 504.047L64.4446 506.349L62.143 510.952L59.8415 506.349L55.2383 504.047L59.8415 501.746L62.143 497.143L64.4446 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip381_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 501.746L96.6669 504.047L92.0638 506.349L89.7622 510.952L87.4606 506.349L82.8574 504.047L87.4606 501.746L89.7622 497.143L92.0638 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip382_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 501.746L124.286 504.047L119.683 506.349L117.381 510.952L115.08 506.349L110.477 504.047L115.08 501.746L117.381 497.143L119.683 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip383_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 501.746L151.905 504.047L147.302 506.349L145 510.952L142.699 506.349L138.096 504.047L142.699 501.746L145 497.143L147.302 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip384_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.921 501.746L179.524 504.047L174.921 506.349L172.62 510.952L170.318 506.349L165.715 504.047L170.318 501.746L172.62 497.143L174.921 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip385_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.54 501.746L207.144 504.047L202.54 506.349L200.239 510.952L197.937 506.349L193.334 504.047L197.937 501.746L200.239 497.143L202.54 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip386_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 501.746L234.762 504.047L230.158 506.349L227.857 510.952L225.555 506.349L220.952 504.047L225.555 501.746L227.857 497.143L230.158 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip387_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 501.746L262.381 504.047L257.778 506.349L255.476 510.952L253.174 506.349L248.571 504.047L253.174 501.746L255.476 497.143L257.778 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip388_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 501.746L290 504.047L285.397 506.349L283.095 510.952L280.794 506.349L276.19 504.047L280.794 501.746L283.095 497.143L285.397 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip389_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 501.746L317.619 504.047L313.016 506.349L310.714 510.952L308.413 506.349L303.81 504.047L308.413 501.746L310.714 497.143L313.016 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip390_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 501.746L345.238 504.047L340.635 506.349L338.333 510.952L336.032 506.349L331.429 504.047L336.032 501.746L338.333 497.143L340.635 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip391_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 501.746L372.857 504.047L368.254 506.349L365.953 510.952L363.651 506.349L359.048 504.047L363.651 501.746L365.953 497.143L368.254 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip392_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.872 501.746L400.476 504.047L395.872 506.349L393.571 510.952L391.269 506.349L386.666 504.047L391.269 501.746L393.571 497.143L395.872 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip393_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 501.746L428.095 504.047L423.492 506.349L421.19 510.952L418.888 506.349L414.285 504.047L418.888 501.746L421.19 497.143L423.492 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip394_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 501.746L455.714 504.047L451.111 506.349L448.809 510.952L446.507 506.349L441.904 504.047L446.507 501.746L448.809 497.143L451.111 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip395_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 501.746L483.333 504.047L478.73 506.349L476.428 510.952L474.127 506.349L469.523 504.047L474.127 501.746L476.428 497.143L478.73 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip396_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 501.746L510.952 504.047L506.349 506.349L504.047 510.952L501.746 506.349L497.143 504.047L501.746 501.746L504.047 497.143L506.349 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip397_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 501.746L538.571 504.047L533.968 506.349L531.666 510.952L529.365 506.349L524.762 504.047L529.365 501.746L531.666 497.143L533.968 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip398_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 501.746L566.19 504.047L561.587 506.349L559.286 510.952L556.984 506.349L552.381 504.047L556.984 501.746L559.286 497.143L561.587 501.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip399_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 529.365L13.8095 531.666L9.20635 533.968L6.90476 538.571L4.60317 533.968L0 531.666L4.60317 529.365L6.90476 524.762L9.20635 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip400_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 529.365L41.4287 531.666L36.8255 533.968L34.5239 538.571L32.2223 533.968L27.6191 531.666L32.2223 529.365L34.5239 524.762L36.8255 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip401_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 529.365L69.0478 531.666L64.4446 533.968L62.143 538.571L59.8415 533.968L55.2383 531.666L59.8415 529.365L62.143 524.762L64.4446 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip402_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 529.365L96.6669 531.666L92.0638 533.968L89.7622 538.571L87.4606 533.968L82.8574 531.666L87.4606 529.365L89.7622 524.762L92.0638 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip403_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 529.365L124.286 531.666L119.683 533.968L117.381 538.571L115.08 533.968L110.477 531.666L115.08 529.365L117.381 524.762L119.683 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip404_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 529.365L151.905 531.666L147.302 533.968L145 538.571L142.699 533.968L138.096 531.666L142.699 529.365L145 524.762L147.302 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip405_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 529.365L179.523 531.666L174.92 533.968L172.619 538.571L170.317 533.968L165.714 531.666L170.317 529.365L172.619 524.762L174.92 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip406_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 529.365L207.143 531.666L202.539 533.968L200.238 538.571L197.936 533.968L193.333 531.666L197.936 529.365L200.238 524.762L202.539 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip407_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 529.365L234.762 531.666L230.158 533.968L227.857 538.571L225.555 533.968L220.952 531.666L225.555 529.365L227.857 524.762L230.158 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip408_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 529.365L262.381 531.666L257.778 533.968L255.476 538.571L253.174 533.968L248.571 531.666L253.174 529.365L255.476 524.762L257.778 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip409_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 529.365L290 531.666L285.397 533.968L283.095 538.571L280.794 533.968L276.19 531.666L280.794 529.365L283.095 524.762L285.397 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip410_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 529.365L317.619 531.666L313.016 533.968L310.714 538.571L308.413 533.968L303.81 531.666L308.413 529.365L310.714 524.762L313.016 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip411_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 529.365L345.238 531.666L340.635 533.968L338.333 538.571L336.032 533.968L331.429 531.666L336.032 529.365L338.333 524.762L340.635 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip412_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 529.365L372.857 531.666L368.254 533.968L365.953 538.571L363.651 533.968L359.048 531.666L363.651 529.365L365.953 524.762L368.254 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip413_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 529.365L400.477 531.666L395.873 533.968L393.572 538.571L391.27 533.968L386.667 531.666L391.27 529.365L393.572 524.762L395.873 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip414_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 529.365L428.096 531.666L423.492 533.968L421.191 538.571L418.889 533.968L414.286 531.666L418.889 529.365L421.191 524.762L423.492 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip415_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 529.365L455.714 531.666L451.111 533.968L448.809 538.571L446.507 533.968L441.904 531.666L446.507 529.365L448.809 524.762L451.111 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip416_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 529.365L483.333 531.666L478.73 533.968L476.428 538.571L474.127 533.968L469.523 531.666L474.127 529.365L476.428 524.762L478.73 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip417_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 529.365L510.952 531.666L506.349 533.968L504.047 538.571L501.746 533.968L497.143 531.666L501.746 529.365L504.047 524.762L506.349 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip418_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 529.365L538.571 531.666L533.968 533.968L531.666 538.571L529.365 533.968L524.762 531.666L529.365 529.365L531.666 524.762L533.968 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip419_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 529.365L566.19 531.666L561.587 533.968L559.286 538.571L556.984 533.968L552.381 531.666L556.984 529.365L559.286 524.762L561.587 529.365Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip420_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20635 556.984L13.8095 559.286L9.20635 561.587L6.90476 566.19L4.60317 561.587L0 559.286L4.60317 556.984L6.90476 552.381L9.20635 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip421_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8255 556.984L41.4287 559.286L36.8255 561.587L34.5239 566.19L32.2223 561.587L27.6191 559.286L32.2223 556.984L34.5239 552.381L36.8255 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip422_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4446 556.984L69.0478 559.286L64.4446 561.587L62.143 566.19L59.8415 561.587L55.2383 559.286L59.8415 556.984L62.143 552.381L64.4446 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip423_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0638 556.984L96.6669 559.286L92.0638 561.587L89.7622 566.19L87.4606 561.587L82.8574 559.286L87.4606 556.984L89.7622 552.381L92.0638 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip424_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 556.984L124.286 559.286L119.683 561.587L117.381 566.19L115.08 561.587L110.477 559.286L115.08 556.984L117.381 552.381L119.683 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip425_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.302 556.984L151.905 559.286L147.302 561.587L145 566.19L142.699 561.587L138.096 559.286L142.699 556.984L145 552.381L147.302 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip426_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.92 556.984L179.523 559.286L174.92 561.587L172.619 566.19L170.317 561.587L165.714 559.286L170.317 556.984L172.619 552.381L174.92 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip427_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.539 556.984L207.143 559.286L202.539 561.587L200.238 566.19L197.936 561.587L193.333 559.286L197.936 556.984L200.238 552.381L202.539 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip428_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.158 556.984L234.762 559.286L230.158 561.587L227.857 566.19L225.555 561.587L220.952 559.286L225.555 556.984L227.857 552.381L230.158 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip429_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.778 556.984L262.381 559.286L257.778 561.587L255.476 566.19L253.174 561.587L248.571 559.286L253.174 556.984L255.476 552.381L257.778 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip430_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.397 556.984L290 559.286L285.397 561.587L283.095 566.19L280.794 561.587L276.19 559.286L280.794 556.984L283.095 552.381L285.397 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip431_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.016 556.984L317.619 559.286L313.016 561.587L310.714 566.19L308.413 561.587L303.81 559.286L308.413 556.984L310.714 552.381L313.016 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip432_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.635 556.984L345.238 559.286L340.635 561.587L338.333 566.19L336.032 561.587L331.429 559.286L336.032 556.984L338.333 552.381L340.635 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip433_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.254 556.984L372.857 559.286L368.254 561.587L365.953 566.19L363.651 561.587L359.048 559.286L363.651 556.984L365.953 552.381L368.254 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip434_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.873 556.984L400.477 559.286L395.873 561.587L393.572 566.19L391.27 561.587L386.667 559.286L391.27 556.984L393.572 552.381L395.873 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip435_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.492 556.984L428.096 559.286L423.492 561.587L421.191 566.19L418.889 561.587L414.286 559.286L418.889 556.984L421.191 552.381L423.492 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip436_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.111 556.984L455.714 559.286L451.111 561.587L448.809 566.19L446.507 561.587L441.904 559.286L446.507 556.984L448.809 552.381L451.111 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip437_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.73 556.984L483.333 559.286L478.73 561.587L476.428 566.19L474.127 561.587L469.523 559.286L474.127 556.984L476.428 552.381L478.73 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip438_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.349 556.984L510.952 559.286L506.349 561.587L504.047 566.19L501.746 561.587L497.143 559.286L501.746 556.984L504.047 552.381L506.349 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip439_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.968 556.984L538.571 559.286L533.968 561.587L531.666 566.19L529.365 561.587L524.762 559.286L529.365 556.984L531.666 552.381L533.968 556.984Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip440_789_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.587 556.984L566.19 559.286L561.587 561.587L559.286 566.19L556.984 561.587L552.381 559.286L556.984 556.984L559.286 552.381L561.587 556.984Z",
    fill: "black"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_789_9267)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: -2,
    width: 567,
    height: 582,
    fill: "url(#paint0_linear_789_9267)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_789_9267",
    x1: 1379,
    y1: 963,
    x2: 308.5,
    y2: 306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18CAB1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 580,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 27.6191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 55.2383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 82.8574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip85_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip86_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip87_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip88_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip89_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip90_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip91_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip92_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip93_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip94_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip95_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip96_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip97_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip98_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip99_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip100_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip101_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip102_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip103_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip104_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 110.477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip105_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip106_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip107_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip108_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip109_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip110_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip111_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip112_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip113_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip114_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip115_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip116_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip117_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip118_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip119_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip120_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip121_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip122_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip123_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip124_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip125_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 138.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip126_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip127_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip128_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip129_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip130_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip131_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip132_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip133_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip134_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip135_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip136_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip137_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip138_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip139_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip140_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip141_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip142_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip143_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip144_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip145_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip146_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 165.714)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip147_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip148_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip149_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip150_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip151_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip152_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip153_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip154_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip155_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip156_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip157_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip158_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip159_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip160_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip161_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip162_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip163_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip164_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip165_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip166_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip167_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 193.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip168_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip169_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip170_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip171_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip172_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip173_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip174_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip175_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip176_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip177_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip178_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip179_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip180_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip181_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip182_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip183_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip184_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip185_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip186_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip187_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip188_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 220.952)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip189_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip190_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip191_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip192_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip193_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip194_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip195_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip196_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip197_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip198_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip199_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip200_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip201_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip202_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip203_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip204_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip205_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip206_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip207_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip208_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip209_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 248.571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip210_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip211_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip212_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip213_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip214_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip215_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip216_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip217_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip218_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip219_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip220_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip221_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip222_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip223_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip224_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip225_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip226_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip227_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip228_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip229_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip230_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 276.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip231_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip232_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip233_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip234_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip235_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip236_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip237_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip238_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip239_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip240_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip241_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip242_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip243_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip244_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip245_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip246_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip247_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip248_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip249_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip250_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip251_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 303.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip252_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip253_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip254_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip255_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip256_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip257_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip258_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip259_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip260_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip261_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip262_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip263_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip264_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip265_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip266_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip267_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip268_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip269_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip270_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip271_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip272_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 331.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip273_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip274_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip275_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip276_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip277_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip278_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip279_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip280_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip281_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip282_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip283_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip284_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip285_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip286_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip287_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip288_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip289_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip290_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip291_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip292_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip293_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 359.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip294_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip295_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip296_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip297_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip298_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip299_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip300_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip301_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip302_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip303_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip304_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip305_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip306_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip307_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip308_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip309_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip310_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip311_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip312_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip313_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip314_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 386.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip315_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip316_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip317_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip318_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip319_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip320_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip321_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip322_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip323_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip324_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip325_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip326_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip327_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip328_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip329_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip330_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip331_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip332_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip333_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip334_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip335_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 414.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip336_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip337_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip338_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip339_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip340_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip341_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip342_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip343_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip344_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip345_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip346_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip347_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip348_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip349_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip350_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip351_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip352_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip353_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip354_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip355_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip356_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 441.904)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip357_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip358_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip359_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip360_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip361_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip362_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip363_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip364_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip365_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip366_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip367_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip368_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip369_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip370_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip371_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip372_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip373_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip374_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip375_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip376_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip377_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 469.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip378_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip379_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip380_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip381_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip382_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip383_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip384_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.715 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip385_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.334 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip386_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip387_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip388_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip389_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip390_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip391_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip392_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.666 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip393_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.285 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip394_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip395_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip396_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip397_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip398_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 497.143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip399_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip400_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip401_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip402_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip403_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip404_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip405_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip406_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip407_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip408_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip409_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip410_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip411_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip412_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip413_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip414_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip415_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip416_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip417_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip418_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip419_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 524.762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip420_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(0 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip421_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(27.6191 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip422_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(55.2383 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip423_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(82.8574 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip424_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(110.477 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip425_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(138.096 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip426_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(165.714 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip427_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(193.333 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip428_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(220.952 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip429_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(248.571 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip430_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(276.19 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip431_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(303.81 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip432_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(331.429 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip433_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(359.048 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip434_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(386.667 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip435_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(414.286 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip436_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(441.904 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip437_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(469.523 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip438_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(497.143 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip439_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(524.762 552.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip440_789_9267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.619,
    height: 27.619,
    fill: "white",
    transform: "translate(552.381 552.381)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.36968fe6e2f6a0c32c5266cb5895e491.svg";
export { ForwardRef as ReactComponent };